import React, { useState } from "react";

import { Link } from "react-router-dom";
import { Card, Modal, ModalBody, ModalHeader } from "reactstrap";

import { Badge } from "components/Badges/Badge";

var Utils = require("Utils");
var Const = require("Const");

export const StudentBadge = ({ persona, course, tags }) => {
  const [zoomImage, setZoomImage] = useState(false);
  // const [modalOpen, setModalOpen] = useState(false);

  // zoomImage: false,

  return (
    <>
      {persona && (
        <>
          <Modal
            toggle={() => setZoomImage(!zoomImage)}
            isOpen={zoomImage}
            size="lg"
          >
            <ModalHeader toggle={() => setZoomImage(!zoomImage)}></ModalHeader>
            <ModalBody>
              <img src={persona.image} alt={persona.last_name} />
            </ModalBody>
          </Modal>

          <Card className="card-user">
            <div className="image">
              <img alt="..." src={require("img/student-badge-back.jpg")} />
            </div>
            <div className="author">
              <img
                alt="..."
                className="avatar border-gray"
                style={persona.image && { cursor: "zoom-in" }}
                onClick={() => {
                  persona.image && setZoomImage(true);
                }}
                src={
                  persona.image
                    ? persona.image
                    : Const.DEFAULT_IMAGE_PROFILE[
                        persona.gender ? persona.gender : "O"
                      ]
                }
              />
              <h5 className="title text-success">
                {Utils.capitalize(persona.last_name + ", " + persona.name)}
              </h5>

              {course && (
                <h5>
                  Curso:{" "}
                  <Link to={"/admin/course/" + course.course_id}>
                    {" "}
                    {course.name}{" "}
                  </Link>{" "}
                </h5>
              )}
              {tags &&
                tags.map((tag) => {
                  return (
                    <Badge
                      bgcolor={tag.tag_color}
                      cancel={() => {
                        alert("bobo");
                      }}
                    >
                      {tag.tag_label}
                    </Badge>
                  );
                })}
            </div>
          </Card>
        </>
      )}
    </>
  );
};
